import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, catchError, of } from 'rxjs';
import { ProfileService } from '../services/profile.service';

/**
 * Admin Guard to protect admin routes.
 * Allows access only for users in admin OR support AD groups.
 */
export const adminGuard: CanActivateFn = () => {
  const router = inject(Router);
  const profileService = inject(ProfileService);

  return profileService.getProfile().pipe(
    map((profile) => {
      if (profile.isAdmin) {
        return true;
      }
      router.navigate(['/home']);
      return false;
    }),
    catchError(() => {
      router.navigate(['/home']);
      return of(false);
    })
  );
};
